const repairPlanAddLossRegister = () => import('@/pages/repairPlan/addlossregister')
const repairPlanquotation = () => import('@/pages/repairPlan/repairPlanquotation')
const repairPlanhistoryquotation = () => import('@/pages/repairPlan/historyquotation')

// const repairPlandiscount = () => import('@/pages/repairPlan/repairPlandiscount')

// 加装
const lossDamage = () => import('@/pages/repairPlan/lossDamage/')

// 随车

const lossAccessory = () => import('@/pages/repairPlan/lossAccessory/')
// 电池定损

const batteryDamage = () => import('@/pages/repairPlan/lossbattery')
const valueServiceLoss = () => import('@/pages/repairPlan/valueServiceLoss')
const batteryItem = () => import('@/pages/repairPlan/lossbattery/batteryItem')

// 损伤定损
const repairPlanCarList = () => import('@/pages/repairPlan/lossproject/lossdamage/repairPlanCarList')
const projectDetail = () => import('@/pages/repairPlan/lossproject/lossdamage/projectDetail')
const damagedDefinition = () => import('@/pages/repairPlan/lossproject/lossdamage/damagedDefinition')
const damagedDefinitionV2 = () => import('@/pages/repairPlan/lossproject/lossdamage/damagedDefinitionV2')
const repairPlanItem = () => import('@/pages/repairPlan/lossproject/lossdamage/repairPlanItem')

const repairPlanDamage = () => import('@/pages/repairPlan/lossproject/tool/smartDamage')
const lossDamgeCanvas = () => import('@/pages/repairPlan/lossproject/lossDamgeCanvas')

// 新随车加装的定损
const lossAccessoryDamageIndex = () => import('@/pages/repairPlan/lossAccessoryDamage/index')
const lossAccessoryDamageDetail = () => import('@/pages/repairPlan/lossAccessoryDamage/validateDetail')
const lossAccessoryabnormal = () => import('@/pages/repairPlan/lossAccessoryDamage/abnormalProject')

export default [
  {
    path: '/repairPlanAddLossRegister',
    name: 'repairPlanAddLossRegister',
    component: repairPlanAddLossRegister,
    meta: {}
  },
  // {
  //   path: '/repairPlandiscount',
  //   name: 'repairPlandiscount',
  //   component: repairPlandiscount,
  //   meta: {
  //     storeKey: 'trs:smartFee'
  //   }

  // },
  // 定损报价
  {
    path: '/repairPlanquotation',
    name: 'repairPlanquotation',
    component: repairPlanquotation,
    meta: {}
  },
  {
    path: '/repairPlanhistoryquotation',
    name: 'repairPlanhistoryquotation',
    component: repairPlanhistoryquotation,
    meta: {}
  },
  {
    path: '/repairPlanDamage',
    name: 'repairPlanDamage',
    component: repairPlanDamage,
    meta: {
      storeKey: 'trs:smartFee'
    }
  },
  {

    path: '/lossDamgeCanvas',
    name: 'LossDamgeCanvas',
    component: lossDamgeCanvas,
    meta: {
    }
  },
  {
    path: '/repairPlanItem',
    name: 'repairPlanItem',
    component: repairPlanItem,
    meta: {}
  },
  {

    path: '/lossAccessory',
    name: 'lossAccessory',
    component: lossAccessory,
    meta: {}
  },
  {
    path: '/lossDamage',
    name: 'lossDamage',
    component: lossDamage,
    meta: {}
  },
  // {
  //   path: '/lossDamageproject',
  //   name: 'lossDamageproject',
  //   component: lossDamageproject,
  //   meta: {}
  // },
  // {
  //   path: '/lossDamageitem',
  //   name: 'lossDamageitem',
  //   component: lossDamageitem,
  //   meta: {}
  // },
  {
    path: '/batteryDamage', // 电池定损登记
    name: 'batteryDamage',
    component: batteryDamage,
    meta: {}
  },
  {
    path: '/valueServiceLoss', // 增值服务定损登记
    name: 'valueServiceLoss',
    component: valueServiceLoss,
    meta: {}
  },
  {
    path: '/batteryItem',
    name: 'batteryItem',
    component: batteryItem,
    meta: {}
  },
  {
    path: '/repairPlanCarList',
    name: 'repairPlanCarList',
    component: repairPlanCarList,
    meta: {}
  },
  {
    path: '/projectDetail',
    name: 'projectDetail',
    component: projectDetail,
    meta: {}
  },
  {
    path: '/damagedDefinition',
    name: 'damagedDefinition',
    component: damagedDefinition,
    meta: {}
  },
  {
    path: '/damagedDefinitionV2',
    name: 'damagedDefinitionV2',
    component: damagedDefinitionV2,
    meta: {}
  },
  {
    path: '/lossAccessoryDamageIndex',
    name: 'lossAccessoryDamageIndex',
    component: lossAccessoryDamageIndex,
    meta: {}
  },
  {
    path: '/lossAccessoryDamageDetail',
    name: 'lossAccessoryDamageDetail',
    component: lossAccessoryDamageDetail,
    meta: {}
  },
  {
    path: '/lossAccessoryabnormal',
    name: 'lossAccessoryabnormal',
    component: lossAccessoryabnormal,
    meta: {}

  }

]



// WEBPACK FOOTER //
// ./src/router/repairPlan/index.js